import { reducerWithInitialState } from "../util/redux/typed-reducers";
import {
    BasicInfoDto,
    PersonInfoDto,
    LoanFinancingDto,
    IncomeOtherLoansDto,
    LivingExpensesDto,
    AgreementsInfoDto,
} from "../util/DTOs/MortgageDtos";
import { ReduxDispatch, ReduxGetState, ReduxState } from "./reducers";
import logger from "../util/logger";
import { env } from "../util/env";
import * as request from "../util/request";
import actionCreatorFactory from "../util/redux/action-factory";
import {
    formValueSelector,
    isValid,
    isDirty,
    getFormValues,
    reset,
} from "redux-form";
import { showSnackbar } from "./snackbar";
import {
    SelectOptions,
    OptionGroup,
    Options,
    Country,
} from "../util/interfaces";
import LoanFinancing from "../views/loans/mortgage/components/LoanFinancing";
import BasicInfo from "../views/loans/mortgage/components/BasicInfo";
import { ApplicationStatusDto } from "util/interfaces";

export interface ApplicationStatuses {
    [key: number]: ApplicationStatusDto;
}

export interface IApplicationsState {
    applications: ApplicationStatuses;
    loading: boolean;
}

const initialInfo: IApplicationsState = {
    applications: {},
    loading: false,
};

const actionFactory = actionCreatorFactory("HypoBongari/Application");

const getApplicationStatusesAction = actionFactory<
    {},
    Array<ApplicationStatusDto>,
    string
>("GET_APPLICATION_STATUSES");

export function getApplicationStatuses() {
    return async (
        dispatch: ReduxDispatch,
        getState: ReduxGetState
    ): Promise<void> => {
        try {
            dispatch(getApplicationStatusesAction({}));

            let response: Array<ApplicationStatusDto>;

            response = await request.get<Array<ApplicationStatusDto>>(
                `${env.APP_API_HOST}/api/loanApplications/statuses/`
            );

            dispatch(getApplicationStatusesAction.done(response));
        } catch (error) {
            logger.error(error);
            dispatch(
                getApplicationStatusesAction.failed(
                    "Lainatietojen hakeminen epäonnistui"
                )
            );

            if (error.status !== 404) {
                dispatch(showSnackbar("Lainatietojen hakeminen epäonnistui"));
            }
            throw error;
        }
    };
}

export const ApplicationReducer = reducerWithInitialState(initialInfo)
    .case(getApplicationStatusesAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getApplicationStatusesAction.done, (state, action) => {
        const loadedApplications = action.payload as ApplicationStatusDto[];
        state.applications = loadedApplications.reduce((acc, app) => {
            return {
                ...acc,
                [app.id]: {
                    ...app,
                },
            };
        }, {});

        return {
            ...state,
            loading: false,
        };
    })
    .case(getApplicationStatusesAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    });

export default ApplicationReducer;

export function getApplications(state: ReduxState) {
    if (state.applications && state.applications.applications) {
        let applications: ApplicationStatusDto[] = Object.keys(
            state.applications.applications
        ).map((key) => {
            return state.applications.applications[key];
        });

        return applications;
    }

    return [] as ApplicationStatusDto[];
}



// WEBPACK FOOTER //
// ./src/ducks/application.ts